import React, {useRef} from "react";
import { AnchorLink } from "gatsby-plugin-anchor-links";
import ComponentWrapper from "../components/wrapper";
import ScrollAnimation from "../helpers/scrollAnimations";
import ToolTip from "./tooltip";

const TableOfContents = ({reverseZindex, introCopy, introCTA, tocTitle, modules, location, hasTooltip, tooltip, storyColor}) => {
  const parentCopyEl = useRef(null);
  const currentPage = location ? location.pathname : "/";

  const getAnchorLinks = (modules) => {
    const anchorLinks = [];
    modules && 
      modules.map( (module, idx, modules) => {
        if (module.__typename === 'WpPage_Tertiarypages_PageContent_AnchorLink' || module.__typename === 'WpPost_Storytellingpage_PageContent_AnchorLink') {
          anchorLinks.push(module.linkTitle);
        }
      })
    return anchorLinks;
  }

  return (
    <ComponentWrapper>
      <ScrollAnimation  zIndex={reverseZindex}>
        <div className="table-of-contents">
          <div className="table-of-contents__intro">
            <div className="table-of-contents__intro-copy" ref={parentCopyEl} dangerouslySetInnerHTML={{__html: introCopy}}></div>
            {hasTooltip &&
              <ToolTip
                  storyColor={storyColor}
                  tooltip={tooltip}
                  parentCopy={parentCopyEl}
              />
            }
            {introCTA &&
              <a className="button table-of-contents__button" href={introCTA.url}>{introCTA.title}</a>
            }
          </div>
          <div className="table-of-contents__list">
            <p className="eyebrow eyebrow--small table-of-contents__title">{tocTitle}</p>
            <ul>
              {getAnchorLinks(modules).map( (link) => {
                const hashLink = link.replace(/\s+/g, '-').toLowerCase();
                return (
                  <li className="table-of-contents__item">
                    <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.60938 0.916016C7.39453 0.916016 7.23828 1.07227 7.23828 1.27734V15.7793L7.27734 17.8594L5.04102 15.5352L1.13477 11.6387C1.06641 11.5703 0.958984 11.541 0.851562 11.541C0.65625 11.541 0.490234 11.6973 0.490234 11.9121C0.490234 12.0195 0.529297 12.1074 0.607422 12.1855L7.33594 18.875C7.41406 18.9531 7.50195 18.9922 7.60938 18.9922C7.7168 18.9922 7.80469 18.9531 7.88281 18.875L14.6113 12.1855C14.6895 12.1074 14.7285 12.0195 14.7285 11.9121C14.7285 11.6973 14.5625 11.541 14.3672 11.541C14.2598 11.541 14.1523 11.5703 14.084 11.6387L10.1777 15.5352L7.94141 17.8594L7.98047 15.7793V1.27734C7.98047 1.07227 7.82422 0.916016 7.60938 0.916016Z" fill="white"/>
                    </svg>

                    <AnchorLink to={`${currentPage}#${hashLink}`} title={link} stripHash>{link}</AnchorLink>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </ScrollAnimation>
    </ComponentWrapper>
  )
}

export default TableOfContents;